import * as SHOP from '../constants/Shop';

const initialState = {
    loading: false,
    error: null,
    shopInfo: {},
    shopAddress: {},
    description: {},
};

export default (state = initialState, action) => {

    switch (action.type) {
        // Get Shop Info 
        case SHOP.GET_SHOP_INFO:
          return {
            ...state,
            loading: true,
            error: null,
          };

        case SHOP.GET_SHOP_INFO_FULFILLED:
          if (action.payload.data) {
            return {
              ...state,
              loading: false,
              shopInfo: action.payload.data,
            };
          }

        case SHOP.GET_SHOP_INFO_CANCELLED:
          return {
            ...state,
            loading: false,
            error: null,
          };

        case SHOP.GET_SHOP_INFO_REJECTED:
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
          
        // Get Shop Info 
        case SHOP.GET_SHOP_ADDRESS:
          return {
            ...state,
            loading: true,
            error: null,
          };
    
        case SHOP.GET_SHOP_ADDRESS_CANCELLED:
          return {
            ...state,
            loading: false,
            error: null,
          };
    
        case SHOP.GET_SHOP_ADDRESS_FULFILLED:
          if (action.payload.data) {
            const { res } = action.payload.data;
            return {
              ...state,
              loading: false,
              shopAddress: res,
            };
          }
    
        case SHOP.GET_SHOP_ADDRESS_REJECTED:
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        case SHOP.GET_SHOP_DESCRIPTION_FULFILLED:
          if (action.payload.data) {
            return {
              ...state,
              description: {
                ...action.payload.data.res.description, 
                coverPhoto: action.payload.data.res.coverPhoto
              },
            };
          }
        default:
            return state;
    }
}